export const data = [
    {
        id: "0",
        question: "What does CAD stand for?",
        answer: "Computer-Aided Design",
        variants: [`Computerized Automation Dogma`, `Calibrating Awesome Drawings`, `Computer-Aided Design`, `Correlated Active Designation`]
    },
    {
        id: "1",
        question: "What do we use CAD for?",
        answer: "Design mechanisms and robots",
        variants: [`Design mechanisms and robots`, `Manage team attendance`, `Incur stress upon others`, `Demonstration tool for other teams`]
    },
    {
        id: "2",
        question: "What is the primary benefit of CAD?",
        answer: "Being able to plan out a design without putting together things blindly.",
        variants: [`Saves time while coding.`, `More effective intra-team communication.`, `Being able to plan out a design without putting together things blindly.`, `A method of learning that can make you better at robotics.`]
    },
    {
        id: "3",
        question: "What kind of account should you sign up for on Onshape?",
        answer: "Student Account",
        variants: [`Student Account`, `Professional Account`, `Free Account`, `High-School Account`]
    },
]

// {
//     id: "3",
//     question: "",
//     answer: "",
//     variants: [``, ``]
// },